import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TankLog } from './tank-log';
import {Tank} from './Tank';

@Injectable({
  providedIn: 'root'
})
export class TankLogService {
  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    if ( error.error && this.isJson(error.error) ) {
      return Promise.reject(JSON.parse(error.error));
    }
    return Promise.reject(error.message || error);
  }

  private isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  get(tankId: string, start: number, end: number) {
    let url = this.basePath + "tank_historic/" + tankId + "/series";

    let params = new HttpParams();
    params = params.append('startDate', start.toString())
      .append('endDate', end.toString());

    return this.http.get(url, { params: params })
      .toPromise()
      .then(res => res as TankLog[])
      .catch( error => this.errorHandler(error) );
  }
}
